import { noop } from 'lodash';
import React, { useState } from 'react';

interface ContextValue {
  selectedPlayerIndex: number;
  setSelectedPlayerIndex: React.Dispatch<React.SetStateAction<number>>;
  numberOfPlayers: number;
  setNumberOfPlayers: React.Dispatch<React.SetStateAction<number>>;
}

export const PrizePlayerProviderContext = React.createContext<ContextValue>({
  selectedPlayerIndex: 0,
  setSelectedPlayerIndex: noop,
  numberOfPlayers: 0,
  setNumberOfPlayers: noop
});

const PrizePlayerProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [selectedPlayerIndex, setSelectedPlayerIndex] = useState(0);
  const [numberOfPlayers, setNumberOfPlayers] = useState(3);

  return (
    <PrizePlayerProviderContext.Provider
      value={{ selectedPlayerIndex, setSelectedPlayerIndex, numberOfPlayers, setNumberOfPlayers }}
    >
      {children}
    </PrizePlayerProviderContext.Provider>
  );
};

export default PrizePlayerProvider;
